import React from 'react';
import { Group, Text } from '@mantine/core';
import { FallbackContentProps } from './FallbackContent';
import { FallbackIcon } from './FallbackIcon';
import { FallbackType } from "@shared-types/auth.types.ts";

export function InlineFallback({action, role, icon}: Omit<FallbackContentProps, 'type' | 'title'>): React.ReactElement {
    return (
        <Group gap="xs" style={{opacity: 0.7}}>
            <FallbackIcon type={FallbackType.Inline} customIcon={icon}/>
            <Text size="sm" c="dimmed" fs="italic">
                {role} role required to {action}
            </Text>
        </Group>
    );
}